<template>
  <router-view />
</template>

<route>
{
  "redirect": "/customer/content_filtering/policies",
  "name": "Customer Content Filtering",
  "meta": {
    "authorize" : [1, 3, 4]
  }
}
</route>

<script>
import { mapActions } from "vuex";
export default {
  layout: "customer",
  methods: mapActions("pageMeta", ["setPageTitle"]),
  created() {
    this.setPageTitle(this.$t("Content Filtering"));
  },
};
</script>
